export default __webpack_public_path__ + "static/media/kabir1.2577ca75.jpg";